import { useQuery } from '@tanstack/react-query';
import { fetchAllTags } from '@/lib/api';

/**
 * Every tag used anywhere in the catalog, for the tag editor's pick-list.
 * Cached for 5 minutes — the tag vocabulary changes slowly.
 */
export function useAllTags() {
  return useQuery({
    queryKey: ['all-tags'],
    queryFn: fetchAllTags,
    staleTime: 5 * 60_000,
  });
}
